var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"navbar-icon mx-1",attrs:{"icon":"","title":"Launch support chat"},on:{"click":function($event){return _vm.launchChat()}}},[_c('i',{staticClass:"fad fa-comment-dots nav-bar-duotone-icon fa-2x"})])}
var staticRenderFns = []

export { render, staticRenderFns }